import { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import NumberFormat from 'react-number-format';
import { Dialog, IconButton, Tooltip } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import moment from 'moment';

import './style/versiones.css';
import { Model } from '../../models/model';
import { iniLoadBudgetsDetailFromVersion } from '../../redux/actions/pptos';

export const VersionesDialogList = ({ open, setOpen, title, idPpto }) => {

    const dispatch = useDispatch()
    const [versionesList, setVersionesList] = useState([])

    const handleGetAll = useCallback(async () => {

        const filtersText = (new URLSearchParams({ id_ppto: idPpto })).toString()
        const params = {
            url: `ppto_versiones/?${filtersText}`
        }

        const dataList = await Model.getAll(params)
        setVersionesList(dataList)

    }, [idPpto])

    const handleVersionVolver = async (infoVersion) => {
        dispatch(iniLoadBudgetsDetailFromVersion(infoVersion))
    }

    useEffect(() => {
        handleGetAll()
    }, [handleGetAll])

    return (
        <>

            {/* {openCobrosDialogForm &&
                <CobrosDialogForm
                    initialData={detailCobro}
                    title='Cobro emitido'
                    openModal={openCobrosDialogForm}
                    setModal={setOpenCobrosDialogForm}
                    dataFactura={dataFactura}
                    checkInitialData={checkInitialData}
                />
            } */}

            <Dialog
                className='dialogModalList'
                open={open}
                onClose={() => setOpen(false)}
                aria-labelledby="simple-dialog-title"
            >
                <div className='ContainerDialogs'>
                    <h1 className='title-lista-pagos'>
                        {title}
                        <IconButton
                            style={{ padding: '0', float: 'right' }}
                            aria-label="close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </IconButton>
                    </h1>

                    {versionesList?.length > 0 ?
                        <div className="table-responsive">
                            <table className="table p-table-global lista-pagos">
                                <thead className='p-thead-global'>
                                    <tr className="text-center p-tr-titles-global">
                                        <th scope="col">Versión</th>
                                        {/* <th scope="col">Tipo</th> */}
                                        <th scope="col">Fecha</th>
                                        <th scope="col">Usuario</th>
                                        <th scope="col">Total neto</th>
                                        <th scope="col"></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {versionesList?.map(item => (
                                        <tr className="text-center p-tr-body-global" key={item.id}>
                                            <td>{item.nombre_version || 'Ninguno'}</td>
                                            {/* <td>{item.tipo_version || 'Ninguno'}</td> */}
                                            <td>{moment(item.fecha).format('DD-MM-YYYY HH:mm') || 'Ninguno'}</td>
                                            <td>{item.usuario || 'Ninguno'}</td>
                                            <td className='text-end'>
                                                <NumberFormat
                                                    value={item.total_neto}
                                                    displayType={'text'}
                                                    thousandSeparator={item.separacion_miles}
                                                    decimalSeparator={item.separacion_decimales}
                                                    decimalScale={2}
                                                    prefix={`${item.simbolo} `}
                                                />
                                            </td>
                                            <td>
                                                {item.version_actual ?
                                                    <Tooltip title={`Versión actual`}>
                                                        <i
                                                            className="bi bi-check-lg"
                                                            style={{ cursor: 'pointer', fontSize: '20px', color: 'green' }}
                                                            onClick={() => handleVersionVolver(item.id)}
                                                        ></i>
                                                    </Tooltip>
                                                    :
                                                    <>
                                                        <Tooltip title={`Vover a la ${item.nombre_version}`}>
                                                            <i
                                                                className="bi bi-reply"
                                                                style={{ cursor: 'pointer', fontSize: '20px' }}
                                                                onClick={() => handleVersionVolver(item)}
                                                            ></i>
                                                        </Tooltip>
                                                        {/* <Tooltip title={`Ver info ${item.nombre_version}`}>
                                                            <i
                                                                className="bi bi-eye ms-3"
                                                                style={{ cursor: 'pointer', fontSize: '20px' }}
                                                                onClick={() => handleVersionVer(item.id)}
                                                            ></i>
                                                        </Tooltip> */}
                                                    </>
                                                }
                                            </td>
                                        </tr>
                                    ))
                                    }
                                </tbody>
                            </table>
                        </div>

                        :

                        <div style={{ width: '400px', textAlign: 'center', padding: '20px' }}>
                            <div style={{ fontSize: '20px' }}>No hay versiones registradas</div>
                            <div style={{ fontSize: '14px', color: 'gray', marginTop: '10px' }}>cada vez que descargas un pdf del presupuesto, se crea una versión</div>
                        </div>

                    }


                </div>
            </Dialog >
        </>
    )
}
